// *******************************************************************************
// Comparison Module
// *******************************************************************************

const comparisonModule = document.querySelector('.comparison-module');

if (comparisonModule) {
  // Get Items
  const toggleItemsClass = () => {
    const emptyMessage = comparisonModule?.querySelector('.comparison-module__empty');
    const listWrapper = comparisonModule?.querySelector('.comparison-module__inner');
    const listEle = comparisonModule?.querySelector('.comparison-module__list');
    const itemEle = listEle?.querySelectorAll('.comparison-module__item');
    comparisonModule.classList.toggle('comparison-module--three-col', itemEle.length === 3);
    comparisonModule.classList.toggle('comparison-module--one-col', itemEle.length === 1);
    const isEmpty = itemEle.length === 0;
    emptyMessage?.classList.toggle('d-none', !isEmpty);
    listWrapper?.classList.toggle('d-none', isEmpty);
  };

  // Calculate Data Height
  const dataEleHeightCalc = () => {
    const houseDataEle = document.querySelectorAll('[comparison-data]');
    const maxHeightMap = {};

    houseDataEle.forEach((ele) => (ele.style.minHeight = 'auto'));

    houseDataEle.forEach((ele) => {
      const key = ele.getAttribute('comparison-data');
      const { height } = ele.getBoundingClientRect();
      maxHeightMap[key] = Math.max(maxHeightMap[key] || 0, height);
    });

    Object.entries(maxHeightMap).forEach(([key, maxHeight]) => {
      document.querySelectorAll(`[comparison-data="${key}"]`).forEach((ele) => {
        ele.style.minHeight = `${maxHeight}px`;
      });
    });
  };

  window.addEventListener('DOMContentLoaded', () => {
    toggleItemsClass();

    setTimeout(() => {
      comparisonModule.classList.remove('show-loader');
      dataEleHeightCalc();
    }, 300);
  });

  window.addEventListener('resize', () => {
    setTimeout(() => {
      dataEleHeightCalc();
    }, 300);
  });

  // Remove Item
  attachEvent('.comparison-module__remove', 'click', (ev) => {
    const sectionEle = ev.target.closest('section');
    const dataId = ev.target.closest('.comparison-module__item')?.getAttribute('data-id');
    sectionEle.querySelectorAll(`[data-id="${dataId}"]`).forEach((item) => item.remove());
    toggleItemsClass();
    removeFromCompareCookie(dataId);

    setTimeout(() => {
      dataEleHeightCalc();
    }, 300);
  });

  // Toggle Sticky Class
  const houseGroup = comparisonModule?.querySelector('.comparison-module__group');
  const listEle = comparisonModule?.querySelector('.comparison-module__list');

  window.addEventListener('scroll', () => {
    const headerHeight = getHeaderHeight();
    const targetPosition = houseGroup?.getBoundingClientRect().top;
    houseGroup?.classList.toggle('is-sticky', targetPosition <= headerHeight);
  });

  // Synchronize Scroll
  const syncScroll = (source, target) => {
    target.scrollLeft = source.scrollLeft;
  };

  houseGroup?.addEventListener('scroll', () => syncScroll(houseGroup, listEle));
  listEle?.addEventListener('scroll', () => syncScroll(listEle, houseGroup));
}
